import Markdown from '@ulta/core/components/Markdown/Markdown';

export default Markdown;